import { County } from "@/types";
import axios from "axios"
import { defineStore } from "pinia"
import { handleError } from "./storeHelper";
import { ref } from "vue";

export const useCountyStore = defineStore('countyStore', () => {

    const apiUrl = "api/v1/county";

    const loading = ref<boolean>(false);

    const items = ref<County[]>([]);

    const list = async function () {

        try {
            loading.value = true;
            const response = await axios.get<County[]>(apiUrl);
            items.value = response.data;
        }
        catch (error) {
            handleError(error);
            throw error;
        }
        finally {
            loading.value = false;
        }        
    }

    return { loading, items, list }
})